<template>
  <layout name="LayoutDefault">
    <div class="Contact">
      <!-- Page Content -->
      <div class="container">
        <!-- Page Features -->
        <div class="contents">
          <!-- <div class="row">
            <div class="alert alert-success col-lg-12">
              আপনার অর্ডারটি সফলভাবে সম্পন্ন হয়েছে । ধন্যবাদ
            </div>
          </div> -->

          <div class="py-5">
            <div class="jumbotron bg-light text-center py-5">
              <!-- Heading -->
              <h2 class="text-success mb-3">
                আপনার অর্ডারটি গ্রহণ করা হয়েছে। আমাদের সাথে থাকার জন্য ধন্যবাদ।
              </h2>

              <!-- Fine-print / return policy -->
              <p class="text-muted mb-4">
                আমাদের একজন প্রতিনিধি শীঘ্রই আপনার সাথে যোগাযোগ করবেন এবং অর্ডারটি নিশ্চিত করবেন।
              </p>

              <!-- Buttons -->
              <div>
                <a href="/" class="btn btn-danger mr-2">
                  Go Back Home
                </a>
                <a href="/customer/dashboard" class="btn btn-outline-danger">
                  Check Order Details
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
      <!-- /.container -->
    </div>
  </layout>
</template>

<script>
import { RouterLink } from "vue-router";
import Layout from "../layouts/Layout";

export default {
  name: `login`,
  components: {
    Layout,
  },
  data() {
    return {
      errors: [],
    };
  },
  mounted() {
    localStorage.setItem("cart", "");
    var cartCount = this.$helper.cartCount();
    $(".cart-count").text(cartCount);
  },
};
</script>
